/*** IMPORTS FROM imports-loader ***/
var define = false;

import * as firebase from "firebase"

function commonSave(path, object){
	console.log("saving");
	console.log(JSON.stringify(object));
	// Remove unset strings
	for(var key in object){
		if(object[key] === ""){
			delete object[key];
		}
	}
	var userId = firebase.auth().currentUser.uid;
	if(object.fireId){
		firebase.database().ref(path + "/" + object.fireId).update(object);
	} else {
		firebase.database().ref(path).push(object);
	}
}

function commonDelete(path, object){
	var userId = firebase.auth().currentUser.uid;
	firebase.database().ref(path + "/" + object.fireId).remove();
}

function commonGet(path, callback){
	var userId = firebase.auth().currentUser.uid;
	firebase.database().ref(path).once("value").then(function(snapshot) {
		var objects = [];
		for(let key in snapshot.val()){
			var object = snapshot.val()[key];
			object["fireId"] = key;
			objects.push(object);
		}
		callback(null, objects);
	})
	.catch(e => {
		console.log(e)
	});
}

function rawGet(path, callback){
	var userId = firebase.auth().currentUser.uid;
	firebase.database().ref(path).once("value").then(function(snapshot) {
		callback(null, snapshot.val());
	})
	.catch(e => {
		console.log(e)
	});
}

function commonGetById(path, id, callback){
	var userId = firebase.auth().currentUser.uid;
	firebase.database().ref(path + "/" + id).once("value").then(function(snapshot) {
		var object = snapshot.val();
		object["fireId"] = id;
		callback(null, object);
	});
}

export default {

	/*

	IMPORTANT

	TODO: add updatedAt and createdAt on save and update

	*/

	// Functions
	rawGet,

	// Presentations
	savePresentation(presentation){
		commonSave("presentations", presentation);
	},
	deletePresentation(presentation){
		commonDelete("presentations", presentation);
	},
	getPresentations(callback){
		commonGet("presentations", callback);
	},
	getPresentationById(id, callback){
		commonGetById("presentations", id, callback);
	},
	
	// Lecturers
	saveLecturer(lecturer){
		commonSave("lecturers", lecturer);
	},
	deleteLecturer(lecturer){
		commonDelete("lecturers", lecturer);
	},
	getLecturers(callback){
		commonGet("lecturers", callback);
	},
	getLecturerById(id, callback){
		commonGetById("lecturers", id, callback);
	},

	// Notifications
	saveNotification(notification){
		commonSave("notifications", notification);
	},
	deleteNotification(notification){
		commonDelete("notifications", notification);
	},
	getNotifications(callback){
		commonGet("notifications", callback);
	},

	// Locations
	saveLocation(location){
		commonSave("locations", location);
	},
	deleteLocation(location){
		commonDelete("locations", location);
	},
	getLocations(callback){
		commonGet("locations", callback);
	},

	// Ratings
	getRatings(callback){
		commonGet("ratings", callback);
	},

	// Comments
	getComments(callback){
		commonGet("comments", callback);
	},

	// Information
	saveInformation(information){
		commonSave("information", information);
	},
	getInformation(callback){
		commonGet("information", callback);
	},

	// Constants
	getConstants(callback){
		firebase.database().ref("constants").once("value").then(function(snapshot) { 
			callback(null, snapshot.val());
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/FirebaseDBService.js